var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"leftButton"},'div',Object.assign({}, _vm.$attrs),false),_vm.$listeners),[_c('span',[_vm._v(_vm._s(_vm.title.substring(0,1)))]),_vm._v("\n   "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }